import m from "../../es2015/lang/it_IT";
window.am4lang_it_IT = m;


//////////////////
// WEBPACK FOOTER
// ./lang/it_IT.js
// module id = null
// module chunks = 